import { render } from "./add-product-modal.vue?vue&type=template&id=91f4a8d4&scoped=true"
import script from "./add-product-modal.vue?vue&type=script&lang=js"
export * from "./add-product-modal.vue?vue&type=script&lang=js"

import "./add-product-modal.vue?vue&type=style&index=0&id=91f4a8d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f4a8d4"]])

export default __exports__